(function() {
  // Perf fase 3: sin jQuery — helpers nativos equivalentes a slideToggle("fast") de jQuery
  // (anima height/padding/margin verticales en 200 ms con overflow:hidden y al final
  // deja display:none o el display por defecto del elemento, igual que jQuery).
  var F3_SLIDE_MS = 200; // jQuery "fast"
  var F3_SLIDE_PROPS = ['height', 'paddingTop', 'paddingBottom', 'marginTop', 'marginBottom'];
  var f3DisplayCache = {};

  function f3DefaultDisplay(el) {
    var name = el.nodeName;
    if (!f3DisplayCache[name]) {
      var temp = document.body.appendChild(document.createElement(name));
      var display = getComputedStyle(temp).display;
      temp.parentNode.removeChild(temp);
      f3DisplayCache[name] = (display === 'none') ? 'block' : display;
    }
    return f3DisplayCache[name];
  }

  function f3ReadBox(el) {
    var cs = getComputedStyle(el);
    var box = {};
    F3_SLIDE_PROPS.forEach(function(p) { box[p] = cs[p]; });
    return box;
  }

  function f3ZeroBox() {
    var box = {};
    F3_SLIDE_PROPS.forEach(function(p) { box[p] = '0px'; });
    return box;
  }

  function f3Slide(el, show) {
    var running = el.__f3slide;
    // Si hay una animación en curso, partimos de los valores actuales (como jQuery)
    var from = running ? f3ReadBox(el) : (show ? f3ZeroBox() : null);
    if (running) {
      running.anim.onfinish = null;
      running.anim.cancel();
    } else {
      el.__f3overflow = el.style.overflow;
    }

    if (show && getComputedStyle(el).display === 'none') {
      el.style.display = el.__f3olddisplay || '';
      if (getComputedStyle(el).display === 'none') el.style.display = f3DefaultDisplay(el);
    }

    var natural = f3ReadBox(el);
    if (!from) from = natural;
    var to = show ? natural : f3ZeroBox();

    el.style.overflow = 'hidden';
    var anim = el.animate([from, to], { duration: F3_SLIDE_MS, easing: 'ease-in-out' });
    el.__f3slide = { anim: anim, show: show };
    anim.onfinish = function() {
      el.__f3slide = null;
      if (!show) {
        if (el.style.display !== 'none') el.__f3olddisplay = el.style.display;
        el.style.display = 'none';
      }
      el.style.overflow = el.__f3overflow || '';
    };
  }

  function f3SlideToggle(el) {
    if (!el) return;
    var hidden = el.__f3slide ? !el.__f3slide.show : getComputedStyle(el).display === 'none';
    if (typeof el.animate !== 'function') { // fallback sin animación
      if (hidden) {
        el.style.display = el.__f3olddisplay || '';
        if (getComputedStyle(el).display === 'none') el.style.display = f3DefaultDisplay(el);
      } else {
        if (el.style.display !== 'none') el.__f3olddisplay = el.style.display;
        el.style.display = 'none';
      }
      return;
    }
    f3Slide(el, hidden);
  }

  // Perf fase 3: sin jQuery — acordeón del footer en móvil.
  // Antes: $(".footer__block-list > div > p").click(...) se volvía a enlazar en cada cambio
  // de la media query (handlers duplicados). Ahora: un único listener delegado que solo
  // actúa mientras la media query (max-width: 767.98px) se cumple.
  var x = window.matchMedia("(max-width: 767.98px)");
  document.addEventListener('click', function(e) {
    if (!x.matches) return;
    var p = e.target.closest ? e.target.closest('p') : null;
    if (!p || !p.matches('.footer__block-list > div > p')) return;
    p.classList.toggle("activated");
    var sib1 = p.nextElementSibling;
    var sib2 = sib1 && sib1.nextElementSibling;
    var sib3 = sib2 && sib2.nextElementSibling;
    f3SlideToggle(sib1);
    f3SlideToggle(sib2);
    f3SlideToggle(sib3);
  });

  // Perf fase 3: sin jQuery — botón "load more" (antes $(document).on('click', ...) + $.get)
  document.addEventListener('click', function(e) {
    var btn = e.target.closest ? e.target.closest('#custom-load-more__btn') : null;
    if (!btn) return;
    e.preventDefault();
    var urlToFetch = btn.getAttribute('data-href');
    if (btn.parentNode) btn.parentNode.remove();
    fetch(urlToFetch || window.location.href, { credentials: 'same-origin' })
      .then(function(res) { return res.ok ? res.text() : null; })
      .then(function(data) {
        if (data == null) return;
        var fetched = new DOMParser().parseFromString(data, 'text/html').querySelector('.product-list');
        if (!fetched) return;
        var htmlToAppend = fetched.innerHTML;
        var targets = document.querySelectorAll('.product-list');
        targets.forEach(function(target, i) {
          var tpl = document.createElement('template');
          tpl.innerHTML = htmlToAppend;
          var scripts = tpl.content.querySelectorAll('script');
          target.appendChild(tpl.content);
          // jQuery.append ejecutaba los <script> insertados (una sola vez): replicamos eso
          if (i === targets.length - 1) {
            scripts.forEach(function(old) {
              var type = old.getAttribute('type') || '';
              if (type && !/^module$|\/(?:java|ecma)script/i.test(type)) return;
              var s = document.createElement('script');
              Array.prototype.forEach.call(old.attributes, function(a) { s.setAttribute(a.name, a.value); });
              s.text = old.textContent;
              old.parentNode.replaceChild(s, old);
            });
          }
        });
      })
      .catch(function() {});
  });
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

/* =============================================
   Parent Nav Link Navigation (SEO + UX fix)
   Makes dropdown parent items clickable as links
   while preserving hover dropdown behavior.
   Added: 2026-03-24
   ============================================= */
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    // DESKTOP: Handle click on dropdown-disclosure summaries with data-url
    document.querySelectorAll('details[is="dropdown-disclosure"] summary[data-url], details[is="mega-menu-disclosure"] summary[data-url]').forEach(function(summary) {
      summary.addEventListener('click', function(e) {
        var url = this.getAttribute('data-url');
        if (url && !e.target.closest('svg') && !e.target.closest('.circle-chevron')) {
          e.preventDefault();
          e.stopPropagation();
          window.location.href = url;
        }
      });
    });
  });
})();
